import React from 'react';
import _ from 'lodash'
import { Row, Col, Container} from 'react-bootstrap'

const Paragraph = ({pContext, pText, tSplitters}) => {
    tSplitters = tSplitters || ['###',' - ',',','[#h--#]','[#--#]','[#,#]','[#|#]']; // [ 'NEW LINE', 'BULLETIN', 'COMMA_SEPARATION', 'TABLE_WITH_HEADER', 'TABLE_WITHOUT_HEADER', 'TABLE_CELL_SEPARATOR', 'TABLE_ROW_SEPARATOR' ]
    pContext = pContext || Math.random().toString();
    //console.log(pText)
    let pTexts = []
    let phTables = [];
    let pTables = [];
    let pTextRefined = pText;
    if(pText != null) {
        if(pTextRefined.indexOf(tSplitters[3]) > -1 || pTextRefined.indexOf(tSplitters[4]) > -1){
            if(pTextRefined.indexOf(tSplitters[3]) > -1){
                // var pTextTables = pTextRefined.match(/(?<=\[\#h--\#\]\s*).*?(?=\s*\[\#h--\#\])/gs);
                var pTextTables = pTextRefined.match(/(?:\[\#h--\#\]\s*).*?(?=\s*\[\#h--\#\])/gs);
                _.forEach(pTextTables, (ptt) => {
                    pTextRefined = pTextRefined.replace(ptt,"").replace(/\[\#h--\#\]/g,"").trim();

                    var lpTable = ptt.replace(/###/g,"").replace(/\[\#h--\#\]/g,"").replace(/\  +/g," ");
                    var lpTableRows = lpTable.split(tSplitters[6]);
                    //var lpTableRowsCells = _.map(lpTableRows, (tr) => { return _.filter(tr.trim().split(tSplitters[5]), (tc) => { return tc !== ""; }) })
                    var lpTableRowsCells = _.map(lpTableRows, (tr) => { return tr.trim().split(tSplitters[5]) })

                    phTables = _.concat(phTables, [ lpTableRowsCells ]);
                })
            }

            if(pTextRefined.indexOf(tSplitters[4]) > -1){
                var pTextTables = pTextRefined.match(/(?:\[\#--\#\]\s*).*?(?=\s*\[\#--\#\])/gs);
                _.forEach(pTextTables, (ptt) => {
                    pTextRefined = pTextRefined.replace(ptt,"").replace(/\[\#--\#\]/g,"").trim();

                    var lpTable = ptt.replace(/###/g,"").replace(/\[\#--\#\]/g,"").replace(/\  +/g," ");
                    var lpTableRows = lpTable.split(tSplitters[6]);
                    //var lpTableRowsCells = _.map(lpTableRows, (tr) => { return _.filter(tr.trim().split(tSplitters[5]), (tc) => { return tc !== ""; }) })
                    var lpTableRowsCells = _.map(lpTableRows, (tr) => { return tr.trim().split(tSplitters[5]) })

                    pTables = _.concat(pTables, [ lpTableRowsCells ]);
                })
            }
        }

        pTextRefined = pTextRefined.replace("null","").trim();
        if(pTextRefined.indexOf("[#|#]") > -1) { pTextRefined = pTextRefined.replace(/(\[#\|#\])+/g,"[#|#]").replace(/\[#\|#\]/g,"###"); }
        pTexts = pTextRefined.split(tSplitters[0]);
    }

    return (
        <div>
            <div>
                {
                    pTexts.length > 0 ? pTexts.map( (item,idx) => (
                        <p key={'paragraph_' + pContext + '_' + idx}>{item.trim()}</p>
                    )) : null
                }
            </div>
            <div>
                {
                    phTables.length > 0 ? phTables.map( (item,idx) => (
                        <Container key={'tab_h_' + idx} className={'header-table'}>
                            { item.map( (thr, thrIdx) => (
                                <div key={'tab_h_' + idx + 'thr_' + thrIdx}>
                                    <div className="page-break"></div>
                                    <Row className={'row'}> {
                                        thr.map( (thc, thcIdx) => (
                                            <Col xs={12/thr.length} md={12/thr.length} key={'tab_h_' + idx + 'thr_' + thrIdx + 'thc_' + thcIdx} className={'cell'}> {thc} </Col>
                                        ) )
                                    } </Row>
                                </div>


                            )) }

                        </Container>
                    )) : null
                }
            </div>
            <div>
                {
                    pTables.length > 0 ? pTables.map( (item,idx) => (
                        <Container key={'tab_' + idx} className={'headerless-table'}>
                            { item.map( (thr, thrIdx) => (
                                <div key={'tab_' + idx + 'thr_' + thrIdx}>
                                    <div className="page-break"></div>
                                    <Row className={'row'}> {
                                        thr.map( (thc, thcIdx) => (
                                            <Col xs={12/thr.length} md={12/thr.length} key={'tab_' + idx + 'thr_' + thrIdx + 'thc_' + thcIdx} className={'cell'}> {thc} </Col>
                                        ) )
                                    } </Row>
                                </div>
                            )) }

                        </Container>
                    )) : null
                }
            </div>

        </div>
    );
};

export default Paragraph;